import { SVGProps } from 'react';
const SvgIconClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    style={{
      transform: 'rotate(45deg)',
    }}
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7513 4.1665C10.7513 3.75229 10.4155 3.4165 10.0013 3.4165C9.58709 3.4165 9.2513 3.75229 9.2513 4.1665V9.24984H4.16797C3.75375 9.24984 3.41797 9.58562 3.41797 9.99984C3.41797 10.4141 3.75375 10.7498 4.16797 10.7498H9.2513V15.8332C9.2513 16.2474 9.58709 16.5832 10.0013 16.5832C10.4155 16.5832 10.7513 16.2474 10.7513 15.8332V10.7498H15.8346C16.2488 10.7498 16.5846 10.4141 16.5846 9.99984C16.5846 9.58562 16.2488 9.24984 15.8346 9.24984H10.7513V4.1665Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconClose;
